import React from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  tipBox: {
    backgroundColor: theme.palette.action.hover,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1.5),
    marginTop: theme.spacing(1),
  },
}));

const TipBox = ({ children }) => {
  const classes = useStyles();
  return (
    <Box className={classes.tipBox}>
      <Typography variant="body1">{children}</Typography>
    </Box>
  );
};

export default TipBox;
